import { DatePicker, TimePicker } from 'antd';
import React from 'react';

import 'antd/dist/antd.css';
import { styled } from '../../assets/theme/index';

const Calendar: React.FunctionComponent<{}> = () => {
  // const today: Date = new Date();
  // const [date, setSelectedDate] = useState(today);

  // const getDate = () => date;

  const setDate = (newDae: Date): void => {
    // setSelectedDate(newDae);
  };

  const updateAndNotifyAgGrid = (newDate: Date): void => {
    setDate(newDate);
    onDateChanged(newDate);
  };

  const onDateChanged = (selectedDates: Date): void => {
    setDate(selectedDates[0]);
    updateAndNotifyAgGrid(selectedDates[0]);
  };

  return (
    <CalendarContainer>
      <StyledDatePicker
        className='ag-input-wrapper custom-date-filter'
        dropdownClassName='ag-custom-component-popup'
        placeholder='Date'
        // onChange={onChange}
        // showToday={true}
      />
      <StyledTimePicker placeholder='Start Time' />
      <StyledTimePicker placeholder='End Time' />
    </CalendarContainer>
  );
};

export default Calendar;

const StyledTimePicker = styled(TimePicker)`
  &&& {
    &&.ant-time-picker {
      align-items: center;
      display: grid;
      grid-template-columns: 1fr auto;
      font-size: 11px;

      .ant-time-picker-input {
        height: 26px;
        border: none;
        order: 2;
        background-color: transparent;
        color: ${({ theme }) => theme.core.textColor};

        &:focus {
          outline: none;
          border: none;
          box-shadow: none;
        }
      }
      .ant-time-picker-icon {
        position: static;
        grid-auto-flow: column;
        order: 1;
        margin: 0;
        color: ${({ theme }) => theme.core.textColor};
      }
    }
  }
`;
const CalendarContainer = styled.div`
  width: 361px;
  background-color: ${({ theme }) => theme.core.alternateBackground};
  border-radius: 13px;
  padding: 0 10px;
  height: 26px;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
`;

const StyledDatePicker = styled(DatePicker)`
  && {
    div {
      align-items: center;
      display: grid;
      grid-template-columns: 1fr auto;
      font-size: 11px;

      .ant-input {
        height: 26px;
        border: none;
        order: 2;
        background-color: transparent;
        color: ${({ theme }) => theme.core.textColor};

        &:focus {
          outline: none;
          border: none;
          box-shadow: none;
        }
      }

      .anticon-calendar,
      .ant-calendar-picker-icon,
      .ant-calendar-picker-clear {
        position: static;
        grid-auto-flow: column;
        order: 1;
        margin: 0;
        color: ${({ theme }) => theme.core.textColor};
      }
    }
  }
`;
